import { SVGProps } from 'react';
const Negative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={15}
    height={8}
    fill='none'
    {...props}
  >
    <path
      fill='#AA0101'
      d='M1.395 0H13.04c1.047 0 1.57 1.221.832 1.933L8.05 7.543a1.2 1.2 0 0 1-1.66 0L.564 1.933C-.175 1.22.348 0 1.395 0Z'
    />
  </svg>
);
export default Negative;
